import React, { useEffect, useRef, useState } from 'react'

import { HiOutlinePlus } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import IconButton from '@/components/common/IconButton'
import TextInput from '@/components/common/TextInput'

interface TextMultiInputProps {
  onSubmit: (value: string) => void
  className?: string
  placeholder?: string
}

const TextMultiInput: React.FC<TextMultiInputProps> = ({
  onSubmit,
  className = '',
  placeholder = '',
}) => {
  const [currentValue, setCurrentValue] = useState<string>('')

  const submitButtonRef = useRef<HTMLButtonElement>(null)

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      submitButtonRef.current?.click()
    }
  }

  const handleSubmit = () => {
    onSubmit(currentValue)
    setCurrentValue('')
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(event.target.value)
  }

  return (
    <div className="relative">
      <TextInput
        className={twMerge('pr-12', className)}
        placeholder={placeholder}
        value={currentValue}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
      {currentValue !== '' && (
        <div className="absolute right-[6px] mt-[1.5px] top-[46%] transform -translate-y-1/2">
          <button
            ref={submitButtonRef}
            onClick={handleSubmit}
            className="flex items-center justify-center hover:opacity-70"
          >
            <span className="text-sm text-primary-700 dark:text-primary-300">
              Add
            </span>
          </button>
        </div>
      )}
    </div>
  )
}

TextMultiInput.displayName = 'TextMultiInput'

export default TextMultiInput
